module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Poptip', {
    attrs: {
      "placement": "bottom",
      "transfer": false
    }
  }, [_c('Badge', {
    attrs: {
      "count": _vm.unreadCount
    }
  }, [_c('Icon', {
    attrs: {
      "type": "turbo-ui-bell"
    }
  })], 1), _vm._v(" "), _c('Tabs', {
    attrs: {
      "animated": false
    },
    slot: "content"
  }, _vm._l((_vm.msgCate), function(cate) {
    return _c('TabPane', {
      attrs: {
        "label": cate.name,
        "name": cate.name
      }
    }, [(_vm.unreadMsg[cate.id] && _vm.unreadMsg[cate.id].categoryCount > 0) ? _c('div', _vm._l((_vm.unreadMsg[cate.id]), function(unreadItem) {
      return _c('div', [(unreadItem.count > 0) ? _c('div', [(cate.id === 1 && unreadItem.typeId != 888) ? _c('a', {
        staticClass: "msg",
        on: {
          "click": function($event) {
            _vm.jumpNotification(unreadItem.typeId)
          }
        }
      }, [_c('span', {
        staticClass: "unread-count"
      }, [_vm._v(_vm._s(unreadItem.count || 100))]), _c('span', {
        staticClass: "unread-desc"
      }, [_vm._v(_vm._s('条' + unreadItem.typeDesc.replace('消息', '')))])]) : _vm._e(), _vm._v(" "), (cate.id !== 1 || unreadItem.typeId === 888) ? _c('a', {
        staticClass: "msg",
        on: {
          "click": function($event) {
            _vm.jumpOther(_vm.OtherMsgTypesMap[unreadItem.typeId])
          }
        }
      }, [_c('span', {
        staticClass: "unread-count"
      }, [_vm._v(_vm._s(unreadItem.count))]), _c('span', {
        staticClass: "unread-desc"
      }, [_vm._v(_vm._s('条' + unreadItem.typeDesc.replace('消息', '')))])]) : _vm._e()]) : _vm._e()])
    })) : _c('div', [_c('a', {
      staticClass: "msg",
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_c('span', {
      staticClass: "unread-desc"
    }, [_vm._v("当前无消息")])])]), _vm._v(" "), (cate.id === 1) ? _c('div', {
      staticClass: "bordertop"
    }, [_c('a', {
      staticClass: "see-all",
      on: {
        "click": _vm.gotoMessageCenter
      }
    }, [_vm._v("查看全部"), _c('i', {
      staticClass: "icon icon-arrow-right"
    })])]) : _vm._e()])
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-559a21de","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/messageCenter.vue
// module id = 920
// module chunks = 0